import React from 'react'
import { useState } from 'react'

import hand from '../src/static/hand.png'
import html from '../src/static/html.svg'
import css from '../src/static/css.svg'
import js from '../src/static/js.svg'
import react from '../src/static/react.svg'
import tailwind from '../src/static/tailwind.svg'
import scss from '../src/static/scss.svg'

import table from "../src/static/table.jpg"

import cars from './/static/cars.jpeg'
import disney from './static/disney.jpeg'
import plants from './static/maali.png'
import shoes from './static/shoes.jpeg'

import { BsLinkedin, BsGithub, BsArrowUpRightSquare } from 'react-icons/bs'
import { FaMapMarkedAlt, FaEnvelopeOpenText } from 'react-icons/fa'
import { RxCross2 } from 'react-icons/rx'
import { HiMenuAlt3 } from 'react-icons/hi'

const App = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <nav>
        <h3 className='logo'>
          Shubham.dev
        </h3>
        <ul className={isMenuOpen ? 'hidden' : ''}>
          <li>
            <a href='#home'>Home</a>
          </li>
          <li>
            <a href='#about'>About</a>
          </li>
          <li>
            <a href='#projects'>Projects</a>
          </li>
          <li>
            <a href='#contact'>Contact</a>
          </li>
          <li>
            <HiMenuAlt3 className='mobile-menu' onClick={toggleMenu} />
          </li>
        </ul>
      </nav>

      <div className={`mobile-nav ${isMenuOpen ? 'open-menu' : 'closed-menu'}`}>
        <span>
          <RxCross2 className='i' onClick={toggleMenu} />
        </span>
        <ul>
          <li>
            <a href='#home' onClick={toggleMenu}>Home</a>
          </li>
          <li>
            <a href='#about' onClick={toggleMenu}>About</a>
          </li>
          <li>
            <a href='#projects' onClick={toggleMenu}>Projects</a>
          </li>
          <li>
            <a href='#contact' onClick={toggleMenu}>Contact</a>
          </li>
        </ul>
      </div>

      <section id='home' className='hero'>
        <div className='container'>
          <div className='content'>
            <div className='hero-main'>
              <div className='hero-text'>
                <h1>Front-End React Developer</h1>
                <img src={hand} alt='waving-hand' />
                <p>Hi, I'm Shubham Mehra. An aspiring Front-end React Developer based in Agra, India. 📍</p>
                <span>
                  <a aria-label='GitHub' rel='noreferrer' target='_blank' href='https://github.com/stretchfps'><BsGithub className='i' /></a>
                  <a aria-label='LinkedIn' rel='noreferrer' target='_blank' href='https://www.linkedin.com/in/shubham-me/'><BsLinkedin className='i' /></a>
                </span>
              </div>
              <div className='hero-img'></div>
            </div>
            <div className='skills'>
              <p> Tech Stack </p>
              <div className='logos'>
                <ul>
                  <li>
                    <img src={html} title='HTML5' alt='skill-icon' />
                  </li>
                  <li>
                    <img src={css} title='CSS3' alt='skill-icon' />
                  </li>
                  <li>
                    <img src={js} title='JavaScript' alt='skill-icon' />
                  </li>
                  <li>
                    <img src={react} title='React' alt='skill-icon' />
                  </li>
                  <li>
                    <img src={tailwind} title='TailWind' alt='skill-icon' />
                  </li>
                  <li>
                    <img src={scss} title='SCSS' alt='skill-icon' />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='about' id='about'>
        <div className='container'>
          <div className='about-content'>
            <div className='image-side'>
              <img src={table} alt='table' className='table-image' />
            </div>
            <div className='text-side'>
              <h3>About Me</h3>
              <h4>A dedicated Front-End Developer
                <br />
                based in Agra, India 📍
              </h4>
              <p>
                In my role as a Junior Front-End Developer, I bring a robust set of abilities encompassing HTML, CSS, JavaScript, React, Tailwind, and SCSS.
                I have a knack for creating and upkeeping responsive websites that provide seamless user interactions. My strength lies in sculpting lively and
                captivating interfaces by composing pristine, efficient code while leveraging state-of-the-art development practices and tools.
                Furthermore, I'm a collaborative team member, thriving in partnerships with diverse groups to deliver exceptional web applications.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className='project' id='projects'>
        <div className='container'>
          <div className='project-content'>
            <p>Portfolio</p>
            <h3>Here are the projects I have created as I am on my path of becoming a full-fledge Front-End Developer 🧩</h3>

            <div className='projects-grid'>
              <div className='pro pro__1 undefined'>
                <div className='pro__img'>
                  <a target='_blank' rel='noreferrer' href='https://crazy-4-cars-rentals.vercel.app/'>
                    <img src={cars} alt='car-rental' style={{ transform: 'translateY(0%)', transition: 'transform 10s ease-in-out 0s' }} />
                  </a>
                </div>
                <div className='pro__text'>
                  <h3>Crazy4Cars 🚗</h3>
                  <p>A car rental website is an online platform allowing users to check and decide on renting cars for personal or business use.
                    The website provides an interface for searching, filtering, showcasing, and
                    checking additional details and specifications of a car of choice.
                  </p>
                  <div className='stack'>
                    <p>NextJS</p>
                    <p>Tailwind</p>
                    <p>TypeScript</p>
                  </div>
                  <div className='links'>
                    <a target='_blank' rel='noreferrer' href='https://github.com/stretchfps/Crazy4Cars'>
                      Code <BsGithub className='i' />
                    </a>
                    <a target='_blank' rel='noreferrer' href='https://crazy-4-cars-rentals.vercel.app/'>
                      Live Demo <BsArrowUpRightSquare className='i' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='pro pro__1 reversed-proj'>
                <div className='pro__img'>
                  <a target='_blank' rel='noreferrer' href='https://disney-clone-stretchfps.vercel.app/'>
                    <img src={disney} alt='car-rental' style={{ transform: 'translateY(0%)', transition: 'transform 10s ease-in-out 0s' }} />
                  </a>
                </div>
                <div className='pro__text'>
                  <h3>Disney+ Clone 📺</h3>
                  <p>This is a project in which I have re-created the home page UI/UX of the wonderful Disney+ website on which there are thousands of movies
                    and TV Shows available to browse thorugh. I have used the TMDB API to fetch the latest and trending movie data which changes automatically.
                  </p>
                  <div className='stack'>
                    <p>ViteJS</p>
                    <p>Tailwind</p>
                  </div>
                  <div className='links'>
                    <a target='_blank' rel='noreferrer' href='https://github.com/stretchfps/Disney-Clone'>
                      Code <BsGithub className='i' />
                    </a>
                    <a target='_blank' rel='noreferrer' href='https://disney-clone-stretchfps.vercel.app/'>
                      Live Demo <BsArrowUpRightSquare className='i' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='pro pro__1 undefined'>
              <div className='pro__img'>
                  <a target='_blank' rel='noreferrer' href='https://shoes-home-page.vercel.app/'>
                    <img src={shoes} alt='shoes-landing-page' style={{ transform: 'translateY(0%)', transition: 'transform 10s ease-in-out 0s' }} />
                  </a>
                </div>
                <div className='pro__text'>
                  <h3>Shoes Landing Page 👟</h3>
                  <p>This is a project in which I have created the home page UI/UX of a shoe brand website landing page with different sections where user can find details about the brand
                    as well as the products and offers on them.
                  </p>
                  <div className='stack'>
                    <p>ViteJS</p>
                    <p>Tailwind</p>
                  </div>
                  <div className='links'>
                    <a target='_blank' rel='noreferrer' href='https://github.com/stretchfps/ShoesHomePage'>
                      Code <BsGithub className='i' />
                    </a>
                    <a target='_blank' rel='noreferrer' href='https://shoes-home-page.vercel.app/'>
                      Live Demo <BsArrowUpRightSquare className='i' />
                    </a>
                  </div>
                </div>
              </div>
              <div className='pro pro__1 reversed-proj'>
              <div className='pro__img'>
                  <a target='_blank' rel='noreferrer' href='https://maali-admin-dashboard.vercel.app/'>
                    <img src={plants} alt='car-rental' style={{ transform: 'translateY(0%)', transition: 'transform 10s ease-in-out 0s' }} />
                  </a>
                </div>
                <div className='pro__text'>
                  <h3>Maali.com 🍀</h3>
                  <p>
                    This is an admin dashboard UI/UX for an online plant-selling website "Maali.com". In this dashboard UI/UX the user can navigate thorugh
                    different options on the side-nav bar, they have the records of the top stats like best seller, recent sold products.
                  </p>
                  <div className='stack'>
                    <p>ReactJS</p>
                    <p>SCSS</p>
                  </div>
                  <div className='links'>
                    <a target='_blank' rel='noreferrer' href='https://github.com/stretchfps/Maali-Admin-Dashboard'>
                      Code <BsGithub className='i' />
                    </a>
                    <a target='_blank' rel='noreferrer' href='https://maali-admin-dashboard.vercel.app/'>
                      Live Demo <BsArrowUpRightSquare className='i' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='contact' id='contact'>
        <div className='container'>
          <div className='contact__content'>
            <div className='contact__title'>
              <p>Contact</p>
              <h3>Don't hesitate, hit me up! 👇</h3>
            </div>
            <div className='contact__icons'>
              <div className='contact__icon-box'>
                <span>
                  <FaMapMarkedAlt className='i' />
                </span>
                <div className='contact__info'>
                  <h3>Location</h3>
                  <p>Agra, India</p>
                </div>
              </div>
              <div className='contact__icon-box'>
                <span>
                  <FaEnvelopeOpenText className='i' />
                </span>
                <div className='contact__info'>
                  <h3>Mail</h3>
                  <a href='mailto:stretchfps.dev@gmail.com'>stretchfps.dev@gmail.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div className='container'>
          <div className='footerc'>
            <h3>Copyright © 2023 . All rights are reserved</h3>
            <div className='footerc__socials'>
              <a aria-label='LinkedIn' rel='noreferrer' target='_blank' href='https://www.linkedin.com/in/shubham-me/'>
                <BsLinkedin className='i' />
              </a>
              <a aria-label='GitHub' rel='noreferrer' target='_blank' href='https://github.com/stretchfps'>
                <BsGithub className='i' />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default App
